<template>
  <ul class="nav">
    <router-link :to="{ path: 'movies', query: { web: selected }}">
      <li :class="selectedPath.includes('movies') ? 'active' : ''">Web</li>
    </router-link>
    <router-link :to="{ path: 'images', query: { image: selected }}">
      <li :class="selectedPath.includes('images') ? 'active' : ''">Images</li>
    </router-link>
  </ul>
</template>

<script>
export default {
  name: "Navigation",
  props: {
    selected:{
      required: true
    }
  },
  data() {
    return {
      selectedPath: this.$route && this.$route.path,
    };
  },
};
</script>